module.exports = __webpack_public_path__ + "static/media/cancel.597dc2fa.svg";